// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"d4ea6250","744":"595f8277","868":"9288f9cd"}[chunkId] + ".chunk.js";
};